import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation } from "swiper/modules";

document.querySelectorAll(".element-mediagallery").forEach((el) => {
  const mainSlider = el.querySelector(".media-gallery .main-slider");

  if (!mainSlider) {
    return;
  }

  const mainSwiper = new Swiper(mainSlider, {
    modules: [A11y, Autoplay, EffectFade, Navigation],
    autoplay: {
      delay: 3000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const thumbnails = el.querySelectorAll(".media-gallery .thumbnail");
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", () => {
      mainSwiper.slideTo(index);
    });
  });

  mainSwiper.on("slideChange", () => {
    const activeIndex = mainSwiper.realIndex;
    thumbnails.forEach((thumbnail, index) => {
      if (index === activeIndex) {
        thumbnail.classList.add("active");
      } else {
        thumbnail.classList.remove("active");
      }
    });
  });

  thumbnails[0].classList.add("active");
});
